import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type {
  ApiSuccess,
  TelegramSettingInput,
  TelegramSettingView,
  TelegramTestResult,
} from '@app/shared';
import { apiClient } from '../../lib/api-client';

const KEY = ['settings', 'telegram'];

export function useTelegramSetting() {
  return useQuery({
    queryKey: KEY,
    queryFn: async (): Promise<TelegramSettingView> => {
      const res = await apiClient.get<ApiSuccess<TelegramSettingView>>('/settings/telegram');
      return res.data.data;
    },
  });
}

export function useUpdateTelegram() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: TelegramSettingInput): Promise<TelegramSettingView> => {
      const res = await apiClient.put<ApiSuccess<TelegramSettingView>>('/settings/telegram', input);
      return res.data.data;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: KEY });
    },
  });
}

export function useTestTelegram() {
  return useMutation({
    mutationFn: async (): Promise<TelegramTestResult> => {
      const res = await apiClient.post<ApiSuccess<TelegramTestResult>>('/settings/telegram/test');
      return res.data.data;
    },
  });
}
